import { render, staticRenderFns } from "./qlbhDetail.vue?vue&type=template&id=71fc49be&scoped=true"
import script from "./qlbhDetail.vue?vue&type=script&lang=js"
export * from "./qlbhDetail.vue?vue&type=script&lang=js"
import style0 from "./qlbhDetail.vue?vue&type=style&index=0&id=71fc49be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fc49be",
  null
  
)

export default component.exports